<div class="sol-app-container">
  <div class="sol-app-navbar"><sol-navbar /></div>
  <div class="sol-app-content" data-shortcut-layer="content">
    <sol-details>
      <sol-topbar />
      <sol-page>
        @if (activeRouteStatus$() === 'loading') {
          <sol-layout p="16"><sol-loader [loader]="SolLoader.ofBlocks(3)" /></sol-layout>
        } @else if (activeRouteStatus$() === 'forbidden') {
          <sol-error-page [type]="SolErrorPageType.FORBIDDEN" />
        } @else {
          <router-outlet />
        }
      </sol-page>
    </sol-details>
  </div>
</div>
<sol-overlays />
<sol-debugger />
